export const GET_MAIN_VIDEO_REQUEST = 'summoner/GET_MAIN_VIDEO_REQUEST';
export const GET_MAIN_VIDEO_SUCCESS = 'summoner/GET_MAIN_VIDEO_SUCCESS';
export const GET_MAIN_VIDEO_FAILURE = 'summoner/GET_MAIN_VIDEO_FAILURE';
